import { Container, Grid, ListItem, Box, Typography } from '@mui/material';
import { Icon24InfoSuccess } from '@care/react-icons';
import { SxClassProps } from '@/types/common';

const classes: SxClassProps = {
  highlightsContainer: {
    paddingTop: 1,
  },
  highlightsInfo: {
    marginTop: 2,
  },
  highlightsList: {
    display: 'flex',
    padding: '0',
    lineHeight: '22px',
    minHeight: '36px',
    alignItems: 'start',
  },
  leftTickIcon: {
    width: '20px',
    height: '20px',
    marginTop: '1px',
    color: 'care.green.800',
  },
  highlightsText: {
    paddingLeft: 2,
    fontWeight: 'bold',
  },
};

interface HighlightsProps {
  qualities: string[];
}

const Highlights = ({ qualities }: HighlightsProps) => {
  return (
    <Container maxWidth="md" sx={classes.highlightsContainer}>
      <Box mb={2}>
        <Typography variant="h3">Highlights</Typography>
      </Box>
      <Grid container>
        {qualities.map((quality) => (
          <Grid item xs={12} lg={4} key={quality}>
            <ListItem sx={classes.highlightsList}>
              <>
                <Icon24InfoSuccess sx={classes.leftTickIcon} />
                <Box sx={classes.highlightsText}>{quality}</Box>
              </>
            </ListItem>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default Highlights;
